<div class="banner" role="banner" *ifScreenSize="screenSize.Desktop">
  <h1>{{ 'account.activity.page.title' | translate }}</h1>
</div>

<ng-container *ifScreenSize="screenSize.Mobile">
  <fgb-barcode></fgb-barcode>
</ng-container>

<fgb-account-nav></fgb-account-nav>

<div class="container">
  <div class="points-history">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
  </div>
</div>
